import api from './api';
import { CPB_URL } from './servers';

export const fetchUsers = () => api.post(`${CPB_URL}/usuarios/getUsuarios`, {});

export const fetchUsersNotRFAndAdmin = () => api.post(`${CPB_URL}/usuarios/getNoRfNoAdmin`, {});

export const fetchUsersNoDisposAsig = () =>
  api.post(`${CPB_URL}/usuarios/getNoDisposAsignados`, {});

export const lockUser = (data) => api.post(`${CPB_URL}/usuarios/lockUser`, data);

export const fetchCatalogsFromSP = () => api.post(`${CPB_URL}/usuarios/getCatalogsForm`, {});

export const fetchUserLadp = (data) => api.post(`${CPB_URL}/usuarios/getUsuarioLADP`, data);

export const postUser = (data) => api.post(`${CPB_URL}/usuarios/postUser`, data);

export const editUserSimac = (data) => api.post(`${CPB_URL}/usuarios/editUsrSimac`, data);

export const reporteUsuariosService = (params) =>
  api.post(`${CPB_URL}/usuarios/getReporteUsuarios`, params);
